import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';

interface ModalFrameProps {
    open: boolean;
    onClose: () => void;
    title: string;
    children: React.ReactNode;
    onConfirm?: () => void;
    onCancel?: () => void;
    showConfirmOnly?: boolean;
}

const ModalFrame: React.FC<ModalFrameProps> = ({
    open,
    onClose,
    title,
    children
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            className='modalFrameLayout'
            open={open}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={onClose}
            disablePortal
        >
            <DialogTitle className='modalFrameTitleContainer'>
                <div className="common-modal-title-container">
                    <Typography variant="h6" component="h2">
                        {title}
                    </Typography>
                    <div>
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>

            <DialogContent className='modalFrameMessageContainer'>
                {children}
            </DialogContent>

            <Divider />
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {t('buttons.close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalFrame;
